import { render } from "./Taxymatch.vue?vue&type=template&id=14b475a7&scoped=true"
import script from "./Taxymatch.vue?vue&type=script&lang=js"
export * from "./Taxymatch.vue?vue&type=script&lang=js"

import "./Taxymatch.vue?vue&type=style&index=0&id=14b475a7&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\nicol\\Code\\portfolio_new\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b475a7"]])

export default __exports__